import { Text } from '@cmpsr/components';

type IntroWizardStepDescriptionProps = {
  activeStep: number;
};

export default function IntroWizardStepDescription(props: IntroWizardStepDescriptionProps) {
  return renderSwitch(props.activeStep);
}

function renderSwitch(activeStep: number): React.ReactNode {
  switch (activeStep) {
    case 1: {
      return (
        <Text variant={{ base: 'text-body-meta-regular', lg: 'text-body-regular' }} color="text-light">
          Each question maps to one or more of{' '}
          <Text as="span" fontWeight="600" color="text-light" fontStyle="italic">
            500+ risk factors
          </Text>{' '}
          identified by the Catch cancer model. By mapping your responses to each of these known cancer risk factors, we
          can calculate your lifetime risk for each of the 21 top cancers and cancer as a whole.
        </Text>
      );
    }
    case 2: {
      return (
        <Text variant={{ base: 'text-body-meta-regular', lg: 'text-body-regular' }} color="text-light">
          We use AI to identify thousands of potential cancer risk factors based on{' '}
          <Text as="span" fontWeight="600" color="text-light" fontStyle="italic">
            clinical research
          </Text>
          , then model these factors using one of the largest patient data sets in the world to identify only those that
          have a{' '}
          <Text as="span" fontWeight="600" color="text-light" fontStyle="italic">
            clinically meaningful
          </Text>{' '}
          impact on cancer risk.
        </Text>
      );
    }
    case 3: {
      return (
        <Text variant={{ base: 'text-body-meta-regular', lg: 'text-body-regular' }} color="text-light">
          Once you complete your Risk Assessment, you will be taken to your{' '}
          <Text as="span" fontWeight="600" color="text-light" fontStyle="italic">
            Member Dashboard
          </Text>
          , where you can see your lifetime risk for cancer as a whole, along with the factors impacting your risk
          positively and negatively.
        </Text>
      );
    }
    case 4: {
      return (
        <Text variant={{ base: 'text-body-meta-regular', lg: 'text-body-regular' }} color="text-light">
          Beyond the dashboard, your Risk Assessment will also power your{' '}
          <Text as="span" fontWeight="600" color="text-light" fontStyle="italic">
            Annual Testing Protocol
          </Text>
          , the optimal cancer screenings to complete over the next year based on your personal risk level for every
          cancer type, and your{' '}
          <Text as="span" fontWeight="600" color="text-light" fontStyle="italic">
            Action Plan
          </Text>
          , which includes the top actions you can take to reduce your risk. Catch members have the potential to reduce
          their risk by up to 60%.
        </Text>
      );
    }
  }
}
